import React, { useCallback } from 'react';
import {
  useRefresh,
  useNotify,
  useCreate,
  useListContext,
} from 'react-admin';

import CallMergeIcon from '@mui/icons-material/CallMerge';
import {
  Button,
  Typography,
} from '@mui/material';
import caseStatuses from '../../../constants/caseStatuses';

const MergeCases = () => {
  const { data, selectedIds, onUnselectItems } = useListContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const [updateMany, { isLoading }] = useCreate();

  const invalidIds = selectedIds.filter((selectedId) => (
    data?.some((item) => item.id === selectedId && item.status === caseStatuses.SCHEDULED)
  ));

  const handleClick = useCallback(() => {
    if (invalidIds.length > 0) notify('Error: Cannot merge scheduled cases', { type: 'warning' });
    else {
      updateMany(
        'cases/merge',
        { data: { selectedIds } },
        {
          onSuccess: () => {
            onUnselectItems();
            refresh();
            notify('Cases merged');
          },
          onError: () => {
            notify('Error: Could not merge cases', { type: 'warning' });
          },
        },
      );
    }
  }, [invalidIds.length, notify, updateMany, selectedIds, onUnselectItems, refresh]);

  return (
    <Button
      onClick={handleClick}
      disabled={isLoading}
      sx={{ paddingX: 1.5, paddingY: 1 }}
    >
      <CallMergeIcon sx={{ marginRight: 1 }} />
      <Typography>Merge</Typography>
    </Button>
  );
};

export default MergeCases;
